import {HttpBackend, HttpClient} from "@angular/common/http";
import { Injectable } from '@angular/core';
import { SigningServiceHttp } from '../../signing-service';
import { environment } from "environments/environment";

@Injectable({
  providedIn: 'root'
})
export class DocumentsTabService {
    private httpClient: HttpClient;
  constructor(
      private http: SigningServiceHttp,
      httpClientHandler: HttpBackend,
    ) {
        this.httpClient = new HttpClient(httpClientHandler); // Create a new instance of HttpClient as BE send complete url (with domain) and we have to bypass the default interceptors
    }

    generatePdf(role_id:number){
        return this.http.get(`sign-document/${role_id}/download-pdf`, {responseType: 'blob'});
    }

    getChatAttachmentPath(path: string, id:number): string {
      return `${environment.apiUrl}documents/${id}/stream-file?path=${path}`;
    }
}
